import { createSelector } from '@reduxjs/toolkit'

import { applyMarketYoyGrowthEdits } from '../../lib'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

/** Fetched records with pending (unsaved) edits overlaid — what the table renders. */
export const selectMarketYoyGrowthExpectationsWithEdits = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => applyMarketYoyGrowthEdits(state.planningDetails, state.edits)
)
